$(document).ready(function(){
  $('.featured-products__slider').slick({
    infinite: true,
    dots: false,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: '<button type="button" class="arrow-right" aria-label="Next product"><img src="//www.eightoclock.com/cdn/shop/t/95/assets/chevron-right.svg?v=15214828179229520951789660358" alt=""></button>',
    prevArrow: '<button type="button" class="arrow-left" aria-label="Previous product"><img src="//www.eightoclock.com/cdn/shop/t/95/assets/chevron-left.svg?v=129821422519446745091789660358" alt=""></button>'
  });

  $(".featured-products__thumbnail").click(function(){
    $(".featured-products__thumbnail").removeClass("active");
    $(this).addClass("active");
    var i = $(this).data("index");
    var color = $(this).data("color");
    var section = $(this).data("section");
    $('.featured-products__slider').slick('slickGoTo', i);
    $('#section-'+section).css('background', color);
  });

  $('.featured-products__slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $(".featured-products__thumbnail").removeClass("active");
        $(".featured-products__thumbnail[data-index='"+nextSlide+"']").addClass("active");
        var color = $(".featured-products__thumbnail[data-index='"+nextSlide+"']").data("color");
        var section = $(".featured-products__thumbnail[data-index='"+nextSlide+"']").data("section");
        $('#section-'+section).css('background', color);

    $(".featured-products__slide-sticker .sticker").hide();
    $(".featured-products__slide-sticker .sticker[data-index='"+nextSlide+"']").show();
  });

  $(".pronunciation .play-audio").click(function(){
    $(this).parent().find("#sahale-pronunciation-audio")[0].play();
  });

  $(".richtext-section .rt-pronunciation .play-audio").click(function(){
    $(this).parent().find("#richtext-audio")[0].play();
  });
});
